package ch.wsl.typings.jspdfAutotable

import ch.wsl.typings.jspdfAutotable.mod.CellInput
import ch.wsl.typings.jspdfAutotable.mod.CellWidthType
import ch.wsl.typings.jspdfAutotable.mod.Color
import ch.wsl.typings.jspdfAutotable.mod.FontStyle
import ch.wsl.typings.jspdfAutotable.mod.FontType
import ch.wsl.typings.jspdfAutotable.mod.HAlignType
import ch.wsl.typings.jspdfAutotable.mod.MarginPaddingInput
import ch.wsl.typings.jspdfAutotable.mod.OverflowType
import ch.wsl.typings.jspdfAutotable.mod.VAlignType
import org.scalablytyped.runtime.StObject
import scala.scalajs.js
import scala.scalajs.js.`|`
import scala.scalajs.js.annotation.{JSGlobalScope, JSGlobal, JSImport, JSName, JSBracketAccess}

object anon {
  
  @js.native
  trait Bottom extends StObject {
    
    var bottom: js.UndefOr[Double] = js.native
    
    var horizontal: js.UndefOr[Double] = js.native
    
    var left: js.UndefOr[Double] = js.native
    
    var right: js.UndefOr[Double] = js.native
    
    var top: js.UndefOr[Double] = js.native
    
    var vertical: js.UndefOr[Double] = js.native
  }
  object Bottom {
    
    @scala.inline
    def apply(): Bottom = {
      val __obj = js.Dynamic.literal()
      __obj.asInstanceOf[Bottom]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: Bottom] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setBottom(value: Double): Self = StObject.set(x, "bottom", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setBottomUndefined: Self = StObject.set(x, "bottom", js.undefined)
      
      @scala.inline
      def setHorizontal(value: Double): Self = StObject.set(x, "horizontal", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setHorizontalUndefined: Self = StObject.set(x, "horizontal", js.undefined)
      
      @scala.inline
      def setLeft(value: Double): Self = StObject.set(x, "left", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setLeftUndefined: Self = StObject.set(x, "left", js.undefined)
      
      @scala.inline
      def setRight(value: Double): Self = StObject.set(x, "right", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setRightUndefined: Self = StObject.set(x, "right", js.undefined)
      
      @scala.inline
      def setTop(value: Double): Self = StObject.set(x, "top", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setTopUndefined: Self = StObject.set(x, "top", js.undefined)
      
      @scala.inline
      def setVertical(value: Double): Self = StObject.set(x, "vertical", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setVerticalUndefined: Self = StObject.set(x, "vertical", js.undefined)
    }
  }
  
  @js.native
  trait DataKey extends StObject {
    
    var dataKey: js.UndefOr[String | Double] = js.native
    
    var footer: js.UndefOr[CellInput] = js.native
    
    var header: js.UndefOr[CellInput] = js.native
    
    var key: js.UndefOr[String | Double] = js.native
    
    var title: js.UndefOr[CellInput] = js.native
  }
  object DataKey {
    
    @scala.inline
    def apply(): DataKey = {
      val __obj = js.Dynamic.literal()
      __obj.asInstanceOf[DataKey]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: DataKey] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setDataKey(value: String | Double): Self = StObject.set(x, "dataKey", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setDataKeyUndefined: Self = StObject.set(x, "dataKey", js.undefined)
      
      @scala.inline
      def setFooter(value: CellInput): Self = StObject.set(x, "footer", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setFooterNull: Self = StObject.set(x, "footer", null)
      
      @scala.inline
      def setFooterUndefined: Self = StObject.set(x, "footer", js.undefined)
      
      @scala.inline
      def setFooterVarargs(value: String*): Self = StObject.set(x, "footer", js.Array(value :_*))
      
      @scala.inline
      def setHeader(value: CellInput): Self = StObject.set(x, "header", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setHeaderNull: Self = StObject.set(x, "header", null)
      
      @scala.inline
      def setHeaderUndefined: Self = StObject.set(x, "header", js.undefined)
      
      @scala.inline
      def setHeaderVarargs(value: String*): Self = StObject.set(x, "header", js.Array(value :_*))
      
      @scala.inline
      def setKey(value: String | Double): Self = StObject.set(x, "key", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setKeyUndefined: Self = StObject.set(x, "key", js.undefined)
      
      @scala.inline
      def setTitle(value: CellInput): Self = StObject.set(x, "title", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setTitleNull: Self = StObject.set(x, "title", null)
      
      @scala.inline
      def setTitleUndefined: Self = StObject.set(x, "title", js.undefined)
      
      @scala.inline
      def setTitleVarargs(value: String*): Self = StObject.set(x, "title", js.Array(value :_*))
    }
  }
  
  @js.native
  trait Height extends StObject {
    
    var height: Double = js.native
    
    var width: Double = js.native
  }
  object Height {
    
    @scala.inline
    def apply(height: Double, width: Double): Height = {
      val __obj = js.Dynamic.literal(height = height.asInstanceOf[js.Any], width = width.asInstanceOf[js.Any])
      __obj.asInstanceOf[Height]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: Height] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setHeight(value: Double): Self = StObject.set(x, "height", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setWidth(value: Double): Self = StObject.set(x, "width", value.asInstanceOf[js.Any])
    }
  }
  
  /* Inlined std.Partial<jspdf-autotable.jspdf-autotable.LineWidths> */
  @js.native
  trait PartialLineWidths extends StObject {
    
    var bottom: js.UndefOr[Double] = js.native
    
    var left: js.UndefOr[Double] = js.native
    
    var right: js.UndefOr[Double] = js.native
    
    var top: js.UndefOr[Double] = js.native
  }
  object PartialLineWidths {
    
    @scala.inline
    def apply(): PartialLineWidths = {
      val __obj = js.Dynamic.literal()
      __obj.asInstanceOf[PartialLineWidths]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: PartialLineWidths] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setBottom(value: Double): Self = StObject.set(x, "bottom", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setBottomUndefined: Self = StObject.set(x, "bottom", js.undefined)
      
      @scala.inline
      def setLeft(value: Double): Self = StObject.set(x, "left", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setLeftUndefined: Self = StObject.set(x, "left", js.undefined)
      
      @scala.inline
      def setRight(value: Double): Self = StObject.set(x, "right", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setRightUndefined: Self = StObject.set(x, "right", js.undefined)
      
      @scala.inline
      def setTop(value: Double): Self = StObject.set(x, "top", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setTopUndefined: Self = StObject.set(x, "top", js.undefined)
    }
  }
  
  /* Inlined std.Partial<jspdf-autotable.jspdf-autotable.Styles> */
  @js.native
  trait PartialStyles extends StObject {
    
    var cellPadding: js.UndefOr[MarginPaddingInput] = js.native
    
    var cellWidth: js.UndefOr[CellWidthType] = js.native
    
    var fillColor: js.UndefOr[Color] = js.native
    
    var font: js.UndefOr[FontType] = js.native
    
    var fontSize: js.UndefOr[Double] = js.native
    
    var fontStyle: js.UndefOr[FontStyle] = js.native
    
    var halign: js.UndefOr[HAlignType] = js.native
    
    var lineColor: js.UndefOr[Color] = js.native
    
    var lineWidth: js.UndefOr[Double | PartialLineWidths] = js.native
    
    var minCellHeight: js.UndefOr[Double] = js.native
    
    var minCellWidth: js.UndefOr[Double] = js.native
    
    var overflow: js.UndefOr[OverflowType] = js.native
    
    var textColor: js.UndefOr[Color] = js.native
    
    var valign: js.UndefOr[VAlignType] = js.native
  }
  object PartialStyles {
    
    @scala.inline
    def apply(): PartialStyles = {
      val __obj = js.Dynamic.literal()
      __obj.asInstanceOf[PartialStyles]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: PartialStyles] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setCellPadding(value: MarginPaddingInput): Self = StObject.set(x, "cellPadding", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setCellPaddingUndefined: Self = StObject.set(x, "cellPadding", js.undefined)
      
      @scala.inline
      def setCellPaddingVarargs(value: Double*): Self = StObject.set(x, "cellPadding", js.Array(value :_*))
      
      @scala.inline
      def setCellWidth(value: CellWidthType): Self = StObject.set(x, "cellWidth", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setCellWidthUndefined: Self = StObject.set(x, "cellWidth", js.undefined)
      
      @scala.inline
      def setFillColor(value: Color): Self = StObject.set(x, "fillColor", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setFillColorUndefined: Self = StObject.set(x, "fillColor", js.undefined)
      
      @scala.inline
      def setFont(value: FontType): Self = StObject.set(x, "font", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setFontSize(value: Double): Self = StObject.set(x, "fontSize", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setFontSizeUndefined: Self = StObject.set(x, "fontSize", js.undefined)
      
      @scala.inline
      def setFontStyle(value: FontStyle): Self = StObject.set(x, "fontStyle", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setFontStyleUndefined: Self = StObject.set(x, "fontStyle", js.undefined)
      
      @scala.inline
      def setFontUndefined: Self = StObject.set(x, "font", js.undefined)
      
      @scala.inline
      def setHalign(value: HAlignType): Self = StObject.set(x, "halign", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setHalignUndefined: Self = StObject.set(x, "halign", js.undefined)
      
      @scala.inline
      def setLineColor(value: Color): Self = StObject.set(x, "lineColor", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setLineColorUndefined: Self = StObject.set(x, "lineColor", js.undefined)
      
      @scala.inline
      def setLineWidth(value: Double | PartialLineWidths): Self = StObject.set(x, "lineWidth", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setLineWidthUndefined: Self = StObject.set(x, "lineWidth", js.undefined)
      
      @scala.inline
      def setMinCellHeight(value: Double): Self = StObject.set(x, "minCellHeight", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setMinCellHeightUndefined: Self = StObject.set(x, "minCellHeight", js.undefined)
      
      @scala.inline
      def setMinCellWidth(value: Double): Self = StObject.set(x, "minCellWidth", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setMinCellWidthUndefined: Self = StObject.set(x, "minCellWidth", js.undefined)
      
      @scala.inline
      def setOverflow(value: OverflowType): Self = StObject.set(x, "overflow", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setOverflowFunction2(value: (/* text */ String | js.Array[String], /* width */ Double) => String | js.Array[String]): Self = StObject.set(x, "overflow", js.Any.fromFunction2(value))
      
      @scala.inline
      def setOverflowUndefined: Self = StObject.set(x, "overflow", js.undefined)
      
      @scala.inline
      def setTextColor(value: Color): Self = StObject.set(x, "textColor", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setTextColorUndefined: Self = StObject.set(x, "textColor", js.undefined)
      
      @scala.inline
      def setValign(value: VAlignType): Self = StObject.set(x, "valign", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setValignUndefined: Self = StObject.set(x, "valign", js.undefined)
    }
  }
  
  @js.native
  trait X extends StObject {
    
    var x: Double = js.native
    
    var y: Double = js.native
  }
  object X {
    
    @scala.inline
    def apply(x: Double, y: Double): X = {
      val __obj = js.Dynamic.literal(x = x.asInstanceOf[js.Any], y = y.asInstanceOf[js.Any])
      __obj.asInstanceOf[X]
    }
    
    @scala.inline
    implicit class MutableBuilder[Self <: X] (val x: Self) extends AnyVal {
      
      @scala.inline
      def setX(value: Double): Self = StObject.set(x, "x", value.asInstanceOf[js.Any])
      
      @scala.inline
      def setY(value: Double): Self = StObject.set(x, "y", value.asInstanceOf[js.Any])
    }
  }
}
